import { ChangePasswordForm } from 'components/forms/users'
import { Modal } from 'components/modal'
import { useDispatch, useSelector } from "react-redux"
import { toggleChangePasswordModal } from "../../../redux/slices/globalSlice"
import { useTranslation } from "react-i18next"

export default function ChangePassword() {

    const { t } = useTranslation()

    const dispatch = useDispatch()

    const show = useSelector((state) => state.global.changePasswordModal)

    const handleClose = () => dispatch(toggleChangePasswordModal())

    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                header={t('profile.change_password')}
                FormPage={ChangePasswordForm}
            />
        </>
    )
}